import { render, staticRenderFns } from "./OrdersPast.vue?vue&type=template&id=4cc408b7"
import script from "./OrdersPast.vue?vue&type=script&lang=js"
export * from "./OrdersPast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports